import { createAction, lt, showErrorAlert, showSuccessAlert } from '@mews/framework';
import { CommanderThunkAction } from '@mews-commander/types';
import { getExchangeRates, changeRates, addRate } from '@mews-commander/legacy-entities/src/ducks/exchangeRates';
import { validateConversionValue } from '../helpers';
import { hasExchangeRatesErrors, getExchangeRatesToUpdate, getExchangeRateIndexUrl } from '../reducers';
import { navigateInModal } from '../../app/actions/common';
import {
    SET_EXCHANGE_RATES,
    RATE_VALUE_CHANGED,
    RATE_FIELD_DIRTY,
    RATE_DIRECTION_TOGGLED,
    RATE_STATUS_TOGGLED,
} from './types';

export const setExchangeRates = (enterpriseId: $TSFixMe) => (dispatch: $TSFixMe, getState: $TSFixMe) => {
    const state = getState();
    return dispatch(createAction(SET_EXCHANGE_RATES, getExchangeRates(state), { scope: enterpriseId }));
};

export const updateConversionValue =
    (currencyCode: $TSFixMe, prevValue: $TSFixMe, newValue: $TSFixMe, scope: $TSFixMe) => (dispatch: $TSFixMe) => {
        if (prevValue !== newValue) {
            const errors = validateConversionValue(newValue);

            return dispatch(createAction(RATE_VALUE_CHANGED, { currencyCode, newValue, errors }, { scope }));
        }
    };

export const updateTouched = (currencyCode: $TSFixMe, scope: $TSFixMe) =>
    createAction(RATE_FIELD_DIRTY, currencyCode, { scope });

export const toggleConversionDirection = (currencyCode: $TSFixMe, scope: $TSFixMe) =>
    createAction(RATE_DIRECTION_TOGGLED, currencyCode, { scope });

export const toggleConversionStatus = (currencyCode: $TSFixMe, scope: $TSFixMe) =>
    createAction(RATE_STATUS_TOGGLED, currencyCode, { scope });

export const updateRatesWithFlash = (scope: $TSFixMe) => (dispatch: $TSFixMe, getState: $TSFixMe) => {
    const state = getState();
    if (hasExchangeRatesErrors(state, { scope })) {
        showErrorAlert({ description: lt('ValidationErrorMessage') });
        return;
    }
    return dispatch(changeRates(scope, getExchangeRatesToUpdate(state, { scope }))).then(() =>
        showSuccessAlert({ description: lt('SaveSuccessMessage') })
    );
};

export const addExchangeRate =
    ({ currencyCode, scope }: $TSFixMe): CommanderThunkAction =>
    (dispatch, getState, { resolveRoute }) => {
        const state = getState();
        return dispatch(addRate(scope, currencyCode)).then(() => {
            const url = getExchangeRateIndexUrl(state, { enterpriseId: scope, resolveRoute });
            dispatch(navigateInModal(url));

            showSuccessAlert({ description: lt('SaveSuccessMessage') });
        });
    };
